import { ModalBodyWrapper, OverlayedLoader } from '@mews-commander/ui';

export interface ModalBodyProps {
    children: React.ReactNode;
    isActive: boolean;
    isFetching: boolean;
}

export const ModalBody: React.FC<ModalBodyProps> = ({ children, isActive, isFetching }) => (
    <>
        {(!isActive || isFetching) && <OverlayedLoader show />}
        {isActive && <ModalBodyWrapper>{children}</ModalBodyWrapper>}
    </>
);
